import { c as _c } from "react/compiler-runtime";
import { UserAvatar } from '@src/components/sco/Account/UserAvatar';
import { AppLayout, attachedAppLayoutPanelProps } from '@src/components/sco/AppLayout';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder';
import { USER_SEARCH_FRAGMENT } from '@src/components/sco/Matching/userSearchFragment';
import { RequestBuilderForms } from '@src/components/sco/Requests/RequestBuilder/RequestBuilderForms';
import { RequestBuilderPreview } from '@src/components/sco/Requests/RequestBuilder/RequestBuilderPreview';
import { useWindow } from '@src/hooks/useWindow';
import { gql } from '@src/lib/gql';
import React from 'react';
type RequestBuilderProps = {
  groupRequestId: string;
};
export const REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT = gql`
  fragment _ on GroupRequest {
    id
    groupRequestId
    groupRequestTypeKey
    groupRequestType {
      id
      title
      key
      colorHexCode
    }
    naturalLanguagePrompt
    displayTitle
    title
    generatedTitle
    description
    location
    locationCity
    locationCountryKey
    locationLatitude
    locationLongitude
    locationState
    needExplanation
    valueToRequester
    valueToResponder
    compensationTypeKeys
    compensationTypes {
      id
      title
      key
    }
    timeCommitmentTypeKeys
    timeCommitmentTypes {
      id
      title
      key
    }
    tagTitles
    skillTagTitles
    investorIndustryTagTitles
    requestingUser {
      id
      userId
      displayName
      firstName
      lastName
      pictureUrl
      title
      ${UserAvatar.fragments.ScoUser()}
    }
    requestingCompany {
      id
      companyId
      name
      elevatorPitch
      stageKey
      stage {
        id
        title
        key
      }
      industries {
        id
        title
        key
      }
      industryKeys
      url
    }
    displayBodyAsMarkdown
    bodyAsMarkdown
    generatedBodyAsMarkdown
    bodyPromptAdditionalItems
    bodyIsGenerated
    visibilityKey
    visibility {
      id
      title
      key
    }
    publishRequestedAt
    publishedAt
    publishStatusKey
    publishStatus {
      id
      title
      key
    }
    tags {
      id
      tagTypeKey
      title
    }
    tagTitles
    investorSearch {
      id
      ${PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT}
    }
    userSearch {
      id
      ${USER_SEARCH_FRAGMENT}
    }
    storedFiles {
      id
      items {
        id
        title
        fullUrl
        storageFileName
        storedFileId
      }
    }
  }
`;
export const RequestBuilder: React.FC<RequestBuilderProps> = props => {
  const $ = _c(19);
  const requestsLayout = useParentAppLayout();
  const window = useWindow();
  const t0 = `${props.groupRequestId}`;
  let t1;
  if ($[0] !== requestsLayout || $[1] !== t0) {
    t1 = <RequestBuilderForms groupRequestId={t0} requestsLayout={requestsLayout} />;
    $[0] = requestsLayout;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      bgColor: "colorPalette.panel",
      borderRadius: 0,
      border: "none"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = {
      id: "request-builder-form",
      children: t1,
      containerProps: t2
    };
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: true,
      lg: false
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== window?.innerWidth) {
    t5 = () => window?.innerWidth ? window?.innerWidth / 2 : 400;
    $[7] = window?.innerWidth;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `${props.groupRequestId}`;
  let t7;
  if ($[9] !== requestsLayout || $[10] !== t6) {
    t7 = <RequestBuilderPreview groupRequestId={t6} requestsLayout={requestsLayout} />;
    $[9] = requestsLayout;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      bgColor: "colorPalette.bg",
      borderRadius: 0,
      border: "none"
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t7) {
    t9 = {
      id: "request-builder-preview",
      useDrawerBreakpoints: t4,
      resizeHandlePosition: "left",
      defaultWidth: t5,
      children: t7,
      containerProps: t8
    };
    $[13] = t5;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <AppLayout id="request-builder" panelProps={attachedAppLayoutPanelProps} scrollable={false} panels={[t3, t9]} />;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};